import Vue from 'vue'
import VueRouter from 'vue-router'
import { parseRoutes, applyDefaultValues, applyMiddlewares } from '~/router/helpers'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((error) => {
        if (error && error.name !== 'NavigationDuplicated') {
            throw error
        }
    })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch((error) => {
        if (error && error.name !== 'NavigationDuplicated') {
            throw error
        }
    })
}

Vue.use(VueRouter)

const Router = new VueRouter({
    base: env('VUE_APP_ROUTER_PATH'),
    mode: 'history',
    routes: parseRoutes(
        require
            .context('./routes/', true, /^\.\/.*\.js$/)
            .keys()
            .reduce((routes, file) => {
                const route = file.replace('./', '').replace('.js', '')
                return routes.concat(require(`./routes/${route}`).default)
            }, [])
            .concat([
                {
                    path: '/*',
                    name: 'errors.not-found',
                    view: 'errors/NotFound',
                },
            ]),
    ),
    scrollBehavior(to, from, savedPosition) {
        return savedPosition || { x: 0, y: 0 }
    },
})

Router.beforeEach((to, from, next) => {
    to = applyDefaultValues(to)
    to = applyMiddlewares(to)

    if (from.name) {
        Router.previousRoute = { ...from }
    }

    next()
})

export default Router
